import React from 'react';

const LinkedInIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-7 w-7" {...props}>
    <rect width="24" height="24" rx="4" fill="white" fillOpacity="0.08" />
    <path d="M16.5 8.5A3.5 3.5 0 0 1 20 12v3.5A3.5 3.5 0 0 1 16.5 19h-9A3.5 3.5 0 0 1 4 15.5V12a3.5 3.5 0 0 1 3.5-3.5h9z" fill="white"/>
    <rect x="6.5" y="10.5" width="2" height="6" rx="1" fill="white"/>
    <rect x="11" y="13" width="2" height="3.5" rx="1" fill="white"/>
    <circle cx="7.5" cy="8.5" r="1" fill="white"/>
  </svg>
);

const EmailIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-7 w-7" {...props}>
    <rect width="24" height="24" rx="4" fill="white" fillOpacity="0.08" />
    <path d="M4 8.5V16a2.5 2.5 0 0 0 2.5 2.5h11A2.5 2.5 0 0 0 20 16V8.5l-8 5-8-5z" fill="white"/>
    <path d="M20 8.5V8A2.5 2.5 0 0 0 17.5 5.5h-11A2.5 2.5 0 0 0 4 8v.5l8 5 8-5z" fill="white"/>
  </svg>
);

const Footer = () => (
  <footer className="bg-[#23272e] border-t border-[#181a1b] py-8 mt-12">
    <div className="container mx-auto px-4 flex flex-col items-center">
      <div className="flex gap-6 mb-3">
        <a
          href="https://www.linkedin.com/in/abd-elhadi-sahia/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="hover:scale-110 transition-transform"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#39c5bb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin-icon lucide-linkedin">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
            <rect width="4" height="12" x="2" y="9"/>
            <circle cx="4" cy="4" r="2"/>
          </svg>
        </a>
        <a
          href="mailto:abdelhadisahia@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Email"
          className="hover:scale-110 transition-transform"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#39c5bb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail">
            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/>
            <rect x="2" y="4" width="20" height="16" rx="2"/>
          </svg>
        </a>
      </div>
      <div className="text-xs text-gray-500">© {new Date().getFullYear()} Alaa. All rights reserved.</div>
    </div>
  </footer>
);

export default Footer; 